"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFeaturedById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Updates a featured object by given ID.
 *
 * Featured object is identified by its stringified `ObjectID`.
 *
 * ## Usage
 *
 * ```ts
 * const featuredId: string = "5f5e555d5a578b6";
 * const featured: Partial<Featured> = {
 *	description: "I actually won this run",
 * };
 *
 * const {
 * 	acknowledged,
 * 	matchedCount,
 * 	modifiedCount,
 * 	upsertedCount,
 * 	upsertedId,
 * } = await sdk.updateFeaturedById({ featuredId, featured });
 * ```
 *
 * @param params.featuredId - ID of the featured object to update.
 * @param params.featured   - Fields to update in the featured object of given ID.
 */
const updateFeaturedById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { featuredId, featured } = params;
    const url = `${BASE_URL}/featured/${featuredId}`;
    const response = yield axios_1.default.put(url, featured, { validateStatus: () => true });
    const { status, data } = response;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.updateFeaturedById = updateFeaturedById;
